var BaseViews = require('./base');
require('./mega-menu-modal/mega-menu-modal.scss');
var MegaMenuModal = BaseViews.LayoutView.extend({
    className: 'fmcy-mega-menu-modal fmcy-plugin-bootstrap',
    template: require('./mega-menu-modal/mega-menu-modal.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                backgroundColor: '#000000',
                textColor: '#ffffff',
                _appChannel: null,
                _menuState: null,
                childView: null,
                animate: false
            }
        );
    },
    ui: {
      btnClose: '.fmcy-mega-menu-btn-close'
    },
    events: {
      'click @ui.btnClose': 'onCloseClicked'
    },
    onCloseClicked: function () {
      this.trigger('close:clicked')
    },
    regions: {
      megaMenuChildRegion: '.mega-menu-child-region'
    },
    _onWindowResize: function (event) {
      this.$el.width($(window).width());
    },
    _renderChildView: function () {
      if (this.options.childView !== null) {
        this.megaMenuChildRegion.show(this.options.childView);
      }
    },
    onRender: function() {
      var self = this;
      this.$el.css({ 'background-color': this.options.backgroundColor });
      this.$el.css({'color': this.options.textColor});
      this._onWindowResize();
      this._renderChildView();

      if (this.options.animate == true) {
        this.$el.css({ 'opacity': 0 });
        window.gsap.to(this.$el, {
          opacity: 1,
          duration: 0.5,
        }).delay(0.01);

        this.ui.btnClose.css({ 'opacity': 0 })
        window.gsap.to(this.ui.btnClose, {
          opacity: 1,
          duration: 0.5,
        }).delay(1);
      } else {
        this.$el.css({ 'opacity': 1 });
        this.ui.btnClose.css({ 'opacity': 1 })
      }

      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(this);
    }
});

module.exports = MegaMenuModal;



/** WEBPACK FOOTER **
 ** ./assets/js/common/mega-menu-modal.js
 **/